import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AbsenceService } from './api/absence.service';
import { AbsenceV2Service } from './api/absenceV2.service';
import { ApplicationService } from './api/application.service';
import { AttendantService } from './api/attendant.service';
import { AuthenticationService } from './api/authentication.service';
import { CallControlService } from './api/callControl.service';
import { ConferenceService } from './api/conference.service';
import { ConfigurationService } from './api/configuration.service';
import { CustomerNotificationService } from './api/customerNotification.service';
import { DirectoryService } from './api/directory.service';
import { DirectoryV2Service } from './api/directoryV2.service';
import { LyncService } from './api/lync.service';
import { MediaAdministrationService } from './api/mediaAdministration.service';
import { MessagingService } from './api/messaging.service';
import { NameValueService } from './api/nameValue.service';
import { PushSubscriptionService } from './api/pushSubscription.service';
import { QueueControlService } from './api/queueControl.service';
import { ServiceAdministrationService } from './api/serviceAdministration.service';
import { SettingsService } from './api/settings.service';
import { StatsticsService } from './api/statstics.service';
import { SupportService } from './api/support.service';
import { SynchronizationService } from './api/synchronization.service';
import { WhitepagesService } from './api/whitepages.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AbsenceService,
    AbsenceV2Service,
    ApplicationService,
    AttendantService,
    AuthenticationService,
    CallControlService,
    ConferenceService,
    ConfigurationService,
    CustomerNotificationService,
    DirectoryService,
    DirectoryV2Service,
    LyncService,
    MediaAdministrationService,
    MessagingService,
    NameValueService,
    PushSubscriptionService,
    QueueControlService,
    ServiceAdministrationService,
    SettingsService,
    StatsticsService,
    SupportService,
    SynchronizationService,
    WhitepagesService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
